import React, { useState } from "react";
import { Box } from "@mui/material";
import { BeaconColumnInfo } from "./BeaconListTypes";
import BeaconSearchText from "../../components/BeaconSearchText";

interface BeaconListActionsProps {
  beaconColumnInfo: BeaconColumnInfo[];
  setBeaconColumnInfo: (columnInfo: BeaconColumnInfo[]) => void;
}

const BeaconListActions: React.FC<BeaconListActionsProps> = (props) => {

  const [columnMenuOpen, setColumnMenuOpen] = useState<boolean>(false);
  const columnButtonRef = React.useRef<HTMLButtonElement>(null);

  function onVisibilityChanged(index: number) {
    var tempColumnInfo = [...props.beaconColumnInfo];
    if (tempColumnInfo.length > index && index >= 0) {
      tempColumnInfo[index].visibility = !tempColumnInfo[index].visibility;
      props.setBeaconColumnInfo(tempColumnInfo);
    }
  }

  return (
    <Box sx={{ display: "flex", alignItems: "end" }}>
      <BeaconSearchText />
      {/* <BeaconColumnButton columnInfo={props.beaconColumnInfo} setColumnInfo={props.setBeaconColumnInfo} /> */}
    </Box>
  );
};

export default BeaconListActions;
